/**
 * Marker that allows us to track usage of hidden UIComponents props.
 *
 * @example
 * <UISelect ignoreCase={asHiddenProp(false} />
 */
export function asHiddenProp(x) {
  return x;
}